module.exports = __webpack_public_path__ + "img/si.fb87a78.svg";